<template>
  <li
    class="-file -audio-file"
    :class="{
      '-has-error': file.error,
    }"
    @click.meta="$_dumpData"
  >
    <span
      class="wticon -play"
      :class="playPauseButtonClass"
      @click="togglePlay"
    />
    <div class="-name" v-text="file.name" />
    <div v-if="loading" class="-duration">
      <span class="-separator">|</span>
      Loading...
    </div>
    <div v-else-if="!playing" class="-duration">
      <span class="-separator">|</span>
      {{ currentTimeText }} / {{ durationText }}
    </div>
    <div class="-size" v-text="fileSize" />

    <i
      v-if="file.error"
      class="-error wticon wticon-information1"
      v-tooltip.extend="{
        title: file.error,
        delay: 0,
      }"
    />

    <i class="-remove wticon wticon-close" title="Remove" @click="onRemove" />
  </li>
</template>

<script>
import app from 'app';
import storyViewBus from '../../views/Story/storyViewBus.js';

export default {
  props: {
    file: { type: [Object, File], required: true },
  },

  data() {
    return {
      loading: true,
      playing: null,
      duration: 0,
      currentTime: 0,
    };
  },

  created() {
    this.url = URL.createObjectURL(this.file.blob);
    this.audio = new Audio(this.url);
    this.audio.addEventListener('loadedmetadata', this.onLoadedMetadata);
    this.audio.addEventListener('canplay', this.onCanPlay);
    this.audio.addEventListener('timeupdate', this.onTimeUpdate);
    this.audio.addEventListener('play', this.onPlay);
    this.audio.addEventListener('pause', this.onPause);
    storyViewBus.mind(this, ['svbPauseRcp']);
  },

  beforeDestroy() {
    URL.revokeObjectURL(this.url);
    this.audio.removeEventListener('loadedmetadata', this.onLoadedMetadata);
    this.audio.removeEventListener('canplay', this.onCanPlay);
    this.audio.removeEventListener('timeupdate', this.onTimeUpdate);
    this.audio.removeEventListener('play', this.onPlay);
    this.audio.removeEventListener('pause', this.onPause);
    this.audio.pause();
    this.audio.src = '';
    this.audio = null;
    storyViewBus.neverMind(this);
  },

  computed: {
    playPauseButtonClass() {
      return this.playing ? 'wticon-pause' : 'wticon-play1';
    },

    fileSize() {
      const MB = 1e6;
      const KB = 1e3;

      let size =
        (this.file.size || this.file.bytes || this.file.sizeBytes) / MB;

      if (size > 1) {
        return `${Math.round(size).toFixed(0)} MB`;
      } else if (size > 0.1) {
        return `${size.toFixed(1)} MB`;
      } else {
        size *= KB;
        return `${Math.round(size).toFixed(0)} KB`;
      }
    },

    durationText() {
      return app.moment.utc(this.duration * 1000).format('m:ss');
    },

    currentTimeText() {
      return app.moment.utc(this.currentTime * 1000).format('m:ss');
    },
  },

  methods: {
    onLoadedMetadata() {
      this.duration = this.audio.duration;
    },

    onTimeUpdate() {
      this.currentTime = this.audio.currentTime;
    },

    onPlay() {
      this.playing = true;
    },

    onPause() {
      this.playing = false;
    },

    onCanPlay() {
      this.loading = false;
    },

    togglePlay() {
      if (this.audio.paused) {
        storyViewBus.$emit('svbPauseRcp');
        this.audio.play();
      } else {
        this.audio.pause();
      }
    },

    onRemove() {
      this.$emit('remove-file-record', { file: this.file });
    },

    svbPauseRcp() {
      this.audio.pause();
    },

    $_dumpData() {
      this.$log(this.$props.file);
    },
  },
};
</script>
